import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "landing-page" }
const _hoisted_2 = { class: "transform-h transform-h--do" }
const _hoisted_3 = { class: "transform-list" }
const _hoisted_4 = { class: "transform-h transform-h--dont text-error" }
const _hoisted_5 = { class: "transform-list" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "feature-trio" }
const _hoisted_8 = { class: "text-medium-emphasis" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "promise-frame bg-surface" }
const _hoisted_12 = { class: "promise-eyebrow" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "promise-meta-label text-disabled" }
const _hoisted_15 = { class: "promise-meta-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LandingHero = _resolveComponent("LandingHero")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_LandingSection = _resolveComponent("LandingSection")!
  const _component_ChatTranscript = _resolveComponent("ChatTranscript")!
  const _component_ConnectorCarousel = _resolveComponent("ConnectorCarousel")!
  const _component_ProviderGrid = _resolveComponent("ProviderGrid")!
  const _component_PatternDiagrams = _resolveComponent("PatternDiagrams")!
  const _component_TracePlate = _resolveComponent("TracePlate")!
  const _component_DoorCard = _resolveComponent("DoorCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LandingHero, {
      onPrimary: _ctx.onHeroPrimary,
      onSecondary: _ctx.onHeroSecondary
    }, null, 8, ["onPrimary", "onSecondary"]),
    _createVNode(_component_LandingSection, {
      meta: _ctx.sections.transform,
      "section-id": "transform"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              md: "6"
            }, {
              default: _withCtx(() => [
                _createElementVNode("h3", _hoisted_2, [
                  _createVNode(_component_v_icon, {
                    icon: "mdi-check-circle-outline",
                    size: "22"
                  }),
                  _cache[0] || (_cache[0] = _createTextVNode(" What you start doing "))
                ]),
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transformDo, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'do' + i,
                      class: "transform-item"
                    }, [
                      _createVNode(_component_v_icon, {
                        icon: item.icon,
                        size: "20",
                        class: "transform-icon--do"
                      }, null, 8, ["icon"]),
                      _createElementVNode("span", null, _toDisplayString(item.text), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              md: "6"
            }, {
              default: _withCtx(() => [
                _createElementVNode("h3", _hoisted_4, [
                  _createVNode(_component_v_icon, {
                    icon: "mdi-close-circle-outline",
                    size: "22"
                  }),
                  _cache[1] || (_cache[1] = _createTextVNode(" What you stop tolerating "))
                ]),
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transformDont, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'dont' + i,
                      class: "transform-item"
                    }, [
                      _createVNode(_component_v_icon, {
                        icon: item.icon,
                        size: "20",
                        class: "text-error"
                      }, null, 8, ["icon"]),
                      _createElementVNode("span", null, _toDisplayString(item.text), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["meta"]),
    _createVNode(_component_LandingSection, {
      meta: _ctx.sections.configure,
      "section-id": "configure",
      variant: "band"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configProse, (p, i) => {
          return (_openBlock(), _createElementBlock("p", {
            key: 'cp' + i,
            class: "prose text-medium-emphasis",
            innerHTML: p
          }, null, 8, _hoisted_6))
        }), 128)),
        _createVNode(_component_ChatTranscript),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configFeatures, (f, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'cf' + i,
              class: "feature-cell"
            }, [
              _createElementVNode("h4", null, _toDisplayString(f.headline), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(f.text), 1)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["meta"]),
    _createVNode(_component_LandingSection, {
      meta: _ctx.sections.tools,
      "section-id": "tools"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ConnectorCarousel)
      ]),
      _: 1
    }, 8, ["meta"]),
    _createVNode(_component_LandingSection, {
      meta: _ctx.sections.providers,
      "section-id": "providers",
      variant: "band"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.providersProse, (p, i) => {
          return (_openBlock(), _createElementBlock("p", {
            key: 'pp' + i,
            class: "prose text-medium-emphasis",
            innerHTML: p
          }, null, 8, _hoisted_9))
        }), 128)),
        _createVNode(_component_ProviderGrid)
      ]),
      _: 1
    }, 8, ["meta"]),
    _createVNode(_component_LandingSection, {
      meta: _ctx.sections.patterns,
      "section-id": "patterns"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_PatternDiagrams)
      ]),
      _: 1
    }, 8, ["meta"]),
    _createVNode(_component_LandingSection, {
      meta: _ctx.sections.specimen,
      "section-id": "specimen"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specimenProse, (p, i) => {
          return (_openBlock(), _createElementBlock("p", {
            key: 'sp' + i,
            class: "prose text-medium-emphasis",
            innerHTML: p
          }, null, 8, _hoisted_10))
        }), 128)),
        _createVNode(_component_TracePlate)
      ]),
      _: 1
    }, 8, ["meta"]),
    _createVNode(_component_LandingSection, {
      meta: _ctx.sections.promise,
      "section-id": "promise"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_v_icon, {
              icon: "mdi-shield-crown-outline",
              size: "16"
            }),
            _cache[2] || (_cache[2] = _createTextVNode(" The Mission Squad promise "))
          ]),
          _createElementVNode("p", {
            class: "promise-statement",
            innerHTML: _ctx.promise.statementHtml
          }, null, 8, _hoisted_13),
          _createVNode(_component_v_row, { class: "promise-meta" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.promise.meta, (m, i) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  key: 'pm' + i,
                  cols: "12",
                  md: "4"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(m.label), 1),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(m.value), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["meta"]),
    _createVNode(_component_LandingSection, {
      meta: _ctx.sections.doors,
      "section-id": "doors",
      variant: "band-top"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { class: "mt-4" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doors, (door) => {
              return (_openBlock(), _createBlock(_component_v_col, {
                key: door.id,
                cols: "12",
                md: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DoorCard, {
                    door: door,
                    onActivate: _ctx.onDoor
                  }, null, 8, ["door", "onActivate"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["meta"])
  ]))
}